











import {
  Prop,
  Vue,
  Component,
} from "@/shared/vuepack";
import { formatCurrency } from "@/shared/currency";

@Component
export default class OfferSummary extends Vue {
  formatCurrency = formatCurrency;

  @Prop()
  isFeeWaived: boolean;

  @Prop()
  incentiveAmount: number;

  get showIncentiveAmount (): boolean {
    return this.incentiveAmount > 0;
  }
}
